import { Component, OnInit, Injectable, PLATFORM_ID, Inject, Input, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable, Subscription  } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from '../../services/product.service';
import { Product } from '../../classes/product';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SignUpComponent } from '../../../pages/sign-up/sign-up.component';
import { Router } from '@angular/router';
import { DataService } from 'src/app/shared/services/data.service';


@Component({
  selector: 'app-settings', 
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  public products: Product[] = [];
  public search = false;
  private user: any;
  public userName = "";
  public itemCount = 0;
  public isProxyUser = false;
  public isAdmin = false;
  @Input('isHomePage') isHomePage: boolean;
  @Input('isLogin') isLogin: boolean;
  @Input('isCart') isCart:boolean;
  @Input('isLocation') isLocation:boolean;
  private countSubscription: Subscription;


  public languages = [{
    name: 'English',
    code: 'en'
  }, {
    name: 'French',
    code: 'fr'
  }];

  public currencies = [{
    name: 'Euro',
    currency: 'EUR',
    price: 0.90 // price of euro
  }, {
    name: 'Rupees',
    currency: 'INR',
    price: 70.93 // price of inr
  }, {
    name: 'Pound',
    currency: 'GBP',
    price: 0.78 // price of euro
  }, {
    name: 'Dollar',
    currency: 'USD',
    price: 1 // price of usd
  }];

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private translate: TranslateService,
    public productService: ProductService,private modalService: NgbModal,public activeModal: NgbActiveModal, private router: Router,
    private dataService: DataService) {
    this.productService.cartItems.subscribe(response =>{ this.products = response; console.log('products:', response);});
    // console.log('isHomePage:', this.isHomePage);
    this.isProxyUser = JSON.parse(localStorage.getItem("isProxyUser"));
    this.user = JSON.parse(localStorage.getItem("user"));
    this.userName = this.user?.userName;
    this.isAdmin = this.user?.role == "sto" ? true : false;

    this.countSubscription= this.dataService.getUpdate().subscribe
             (count => { //message contains the data sent from service
             this.itemCount = count;
             });
  }

  ngOnInit(): void {
    // console.log('isHomePage:', this.isHomePage);
  }

  searchToggle(){
    this.search = !this.search;
  }

  changeLanguage(code){
    if (isPlatformBrowser(this.platformId)) {
      this.translate.use(code);
    }
  }

  get getTotal(): Observable<number> {
    return this.productService.cartTotalAmount();
  }

  removeItem(product: any) {
    this.productService.removeCartItem(product);
  }

  changeCurrency(currency: any) {
    this.productService.Currency = currency;
  }
  proxyLogin() {
    localStorage.setItem("isProxyUser", "true");
    this.loginModal();
  }
  loginModal() {
    this.closeModal();
    const signUpModal = this.modalService.open(SignUpComponent, {ariaLabelledBy: 'modal-basic-title'});
    signUpModal.componentInstance.actionEvent = 'signin'; 

  }
    closeModal() {

      this.activeModal.close('close');
    }
    logout(){
      console.log("logout");  
      localStorage.removeItem('user');
      localStorage.removeItem('isProxyUser');
      localStorage.clear();
      this.router.navigate(['/']);
      window.location.reload();
    }
  // openScrollableContent(longContent) {
  //   this.modalService.open(longContent, { scrollable: true });
  // }
  // open(content) {
  //   this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
  //     this.closeResult = `Closed with: ${result}`;
  //   }, (reason) => {
  //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //   });
  // }

}